(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hxWishlistCountInit) return;
    window.hxWishlistCountInit = true;

    const watched = new WeakSet();

    const sync = (link) => {
      const badge = link.querySelector('[data-hx-wl-count]');
      const num = link.querySelector('[data-hx-wl-num]');
      if (!badge || !num) return;
      const source = link.querySelector('.wishlist-hero-items-count');
      const visible = Boolean(source) && source.style.display !== 'none';
      const match = source ? source.textContent.match(/\d+/) : null;
      const count = match ? parseInt(match[0], 10) : 0;
      const text = visible && count > 0 ? (count > 99 ? '99+' : String(count)) : '';
      if (num.textContent !== text) num.textContent = text;
      if (badge.hidden !== (text === '')) badge.hidden = text === '';
    };

    const watch = () => {
      document.querySelectorAll('.hx-action--wishlist').forEach((link) => {
        sync(link);
        if (watched.has(link)) return;
        watched.add(link);
        new MutationObserver(() => sync(link)).observe(link, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['style', 'class'],
        });
      });
    };

    let queued = false;
    const start = () => {
      watch();
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          watch();
        });
      }).observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-preview-links"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.pplReady) return;
    window.pplReady = true;
    const stop = (dialog) => {
      const media = dialog.querySelector('iframe, video');
      if (!media) return;
      if (media.tagName === 'VIDEO') media.pause();
      media.removeAttribute('src');
      if (media.tagName === 'VIDEO') media.load();
    };
    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-ppl-open]');
      if (open) {
        const dialog = open.parentElement.querySelector('[data-ppl-dialog]');
        if (!dialog) return;
        const media = dialog.querySelector('iframe, video');
        if (media && media.dataset.src) media.src = media.dataset.src;
        if (media && media.tagName === 'VIDEO') media.play().catch(() => {});
        dialog.showModal();
        return;
      }
      const close = event.target.closest('[data-ppl-close]');
      const backdrop = event.target.matches && event.target.matches('[data-ppl-dialog]');
      if (close || backdrop) {
        const dialog = close ? close.closest('[data-ppl-dialog]') : event.target;
        dialog.close();
      }
    });
    document.addEventListener(
      'close',
      (event) => {
        if (event.target.matches && event.target.matches('[data-ppl-dialog]')) stop(event.target);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
